/**
 * Admin — GEN-PX-017/023. Botón del raíl (último grupo): la instalación de la plataforma. Sus entradas (Herramientas, Modelos, Marca
 * y estilo, Coste y Salud) las lista el carril contextual junto al raíl; esta pantalla abre la que el carril marca (`subId`) y, por
 * defecto, la primera. Las entradas salen de los ítems que el kernel emite al administrador (R-PT-02); ver `lib/admin.js`.
 */
import { useSession } from '../context/SessionContext.jsx'
import { useFotoAgente } from '../context/FotosAgentes.jsx'
import { pestanasAdmin } from '../lib/admin.js'
import CabeceraLanding from './CabeceraLanding.jsx'
import HerramientasPanel from './HerramientasPanel.jsx'
import ModelosPanel from './ModelosPanel.jsx'
import CostePanel from './CostePanel.jsx'
import SaludPanel from './SaludPanel.jsx'
import LibroEstilo from '../despacho/LibroEstilo.jsx'

const ID_ADMIN = 'admin'

// Vista de cada entrada; una entrada nueva de instalación es una línea aquí y otra en `lib/admin.js`.
const VISTAS = {
  herramientas: HerramientasPanel,
  modelos: ModelosPanel,
  'libro-de-estilo': LibroEstilo,
  coste: CostePanel,
  salud: SaludPanel,
}

// `subId` es la entrada que marca el carril; `viewId` es la vista que pidió el armazón: `admin` abre la primera entrada y una entrada
// concreta (p. ej. la ruta oculta del libro de estilo) abre esa.
export default function InstalacionPanel({ viewId, subId = null, onNavegar = null }) {
  const { capabilities, agents = [] } = useSession()
  const fotoDe = useFotoAgente()
  const entradas = pestanasAdmin(capabilities?.menu)
  if (entradas.length === 0) return <section className="mec-visor" aria-label="Admin"><p className="dk-meta">No hay nada que configurar con tu perfil.</p></section>
  const activa = entradas.find(p => p.id === (subId ?? viewId)) ?? entradas[0]
  const Vista = VISTAS[activa.id]
  // GEN-PX-025: cabecera de Jorge que emite el kernel (lo que necesita atención en la instalación); aquí solo se pinta.
  const cab = capabilities?.menu?.find(m => m?.id === ID_ADMIN)?.cabecera
  const ag = cab?.agente && (agents.find(a => a.id === cab.agente.id) ?? cab.agente)
  const cifras = (cab?.cifras ?? []).filter(c => VISTAS[c.seccion]).map(c => ({ texto: c.texto, onClick: () => onNavegar?.(ID_ADMIN, c.seccion) }))
  return (
    <section className="dk-instalacion" aria-label="Admin">
      {cab && (
        <CabeceraLanding
          agente={ag ? { nombre: cab.agente.nombre, rol: cab.agente.rol, foto: fotoDe(ag) } : null}
          titulo={cab.titulo}
          texto={cab.texto}
          cifras={cifras}
        />
      )}
      <Vista key={activa.id} />
    </section>
  )
}
